import React from "react";

interface DeliveryOptionProps {
  headline: string;
  price: string;
  info1: string;
  info2: string;
  imageSrc: string;
  footerContent?: React.ReactNode;
  isSelected?: boolean;
  onClick?: () => void;
  onClickDetail?: () => void;
  showDetailButton?: boolean;
}

const DeliveryOption: React.FC<DeliveryOptionProps> = ({
  headline,
  price,
  info1,
  info2,
  imageSrc,
  footerContent,
  isSelected = false,
  onClick,
  onClickDetail,
  showDetailButton = false,
}) => {
  const containerStyle: React.CSSProperties = {
    position: "relative",
    padding: "20px 15px",
    border: "1px solid #d3d7da",
    borderRadius: "8px",
    backgroundColor: isSelected ? "#fff9f0" : "#f6f4f2",
    fontFamily: "Avenir Next Codensed Regular",
    color: "rgb(52, 39, 20)",
    boxShadow: isSelected
      ? "0 4px 12px rgba(0, 0, 0, 0.2)"
      : "0 4px 6px rgba(0, 0, 0, 0.1)",
    marginBottom: "20px",
    overflow: "hidden",
    borderWidth: isSelected ? "1px 1px 4px 1px" : "1px",
    borderColor: isSelected ? "#000" : "#d3d7da",
    cursor: "pointer",
    transition: "all 0.3s ease",
  };

  const headlineStyle: React.CSSProperties = {
    fontSize: "1.5rem",
    fontWeight: 600,
    marginBottom: "10px",
    color: "#514633",
  };

  const imageStyle: React.CSSProperties = {
    position: "absolute",
    top: "15px",
    right: "15px",
    width: "40px",
    height: "40px",
    objectFit: "contain",
  };

  const bodyStyle: React.CSSProperties = {
    marginBottom: "20px",
  };

  const infoStyle: React.CSSProperties = {
    fontSize: "1rem",
    marginBottom: "8px",
    lineHeight: "1.5",
  };

  const footerStyle: React.CSSProperties = {
    borderTop: "1px solid #d3d7da",
    paddingTop: "15px",
    textAlign: "right",
  };

  const detailButtonStyle: React.CSSProperties = {
    marginTop: "10px",
    padding: "6px 12px",
    fontSize: "0.9rem",
    border: "none",
    borderRadius: "4px",
    backgroundColor: "#c39d63",
    color: "#fff",
    cursor: "pointer",
    fontFamily: "Avenir Next Codensed Regular",
    transition: "background-color 0.3s",
  };

  return (
    <div style={containerStyle} onClick={onClick}>
      <div>
        <h3 style={headlineStyle}>{headline}</h3>
        <img src={imageSrc} alt={headline} style={imageStyle} />
      </div>

      <div style={bodyStyle}>
        <div style={{ ...infoStyle, fontWeight: 600 }}>{price}</div>
        <div style={infoStyle}>{info1}</div>
        <div style={infoStyle}>{info2}</div>

        {showDetailButton && onClickDetail && (
          <button
            style={detailButtonStyle}
            onClick={(e) => {
              e.stopPropagation(); // verhindert onClick der Karte
              onClickDetail();
            }}
          >
            Store wählen
          </button>
        )}
      </div>

      {footerContent && <div style={footerStyle}>{footerContent}</div>}
    </div>
  );
};

export default DeliveryOption;
